import { ApolloLink, Observable } from '@apollo/client';

import { familyTreeMocks } from '@/modules/familyTree/__mocks__';
import { diagnostics } from '@/utils/diagnostics';

export const mockFamilyTreeLink = new ApolloLink((operation, forward) => {
  // Only run on client side
  if (typeof window === 'undefined') {
    return forward(operation);
  }

  // Check for familyTreeMock query parameter
  const searchParams = new URLSearchParams(window.location.search);
  const mockId = searchParams.get('familyTreeMock');

  // Only intercept GetHouseholdFamilyTree queries when mock parameter is present
  if (mockId && operation.operationName === 'GetHouseholdFamilyTree') {
    const mockData = familyTreeMocks[mockId];

    if (mockData) {
      diagnostics.debug(
        `[Mock Family Tree] Loading mock ${mockId} for manual testing`
      );

      // Return mock data as an observable
      return new Observable((observer) => {
        observer.next({ data: mockData.data });
        observer.complete();
      });
    } else {
      diagnostics.warn(
        `[Mock Family Tree] Mock ID ${mockId} not found. Available mocks: 1-19`
      );
    }
  }

  // For all other operations, proceed normally
  return forward(operation);
});
